import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UpdateCoupons.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

// Coupons
function UpdateCoupons() {
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const raerAcess = localStorage.getItem("raerAcess");
  useEffect(() => {
    console.log(raerAcess);
    if (raerAcess !== "1" || !tokena) {
      navigate("/login");
      return;
    }
  });

  let { couponId } = useParams();

  const [inputHandler, setInputHandler] = useState({
    code: "",
    minimumAmount: 0,
    discountPercent: 0,
    description: "",
    active: true,
    maxUses: 0,
  });

  const onChangeInputHandler = (e) => {
    const { name, value } = e.target;
    setInputHandler({ ...inputHandler, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const config = {
      url:
        process.env.REACT_APP_BASE_URL + `api/updateDiscountCoupon/${couponId}`,
      method: "put",
      data: {
        code: inputHandler?.code,
        minimumAmount: inputHandler?.minimumAmount,
        discountPercent: inputHandler?.discountPercent,
        active: inputHandler?.active,
        show: inputHandler?.show,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          // setDropdown(response?.data?.data);

          //   toast.success("Product Added Successfully", {
          //     position: "bottom-right",
          //     autoClose: 4000,
          //     pauseOnHover: true,
          //     draggable: true,
          //     theme: "light",
          //   });
          navigate("/dashboard");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const getSingleCouponsData = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getSingleCoupons/${couponId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          setInputHandler(response?.data?.data);
          // setDropdown(response?.data?.data);

          //   toast.success("Product Added Successfully", {
          //     position: "bottom-right",
          //     autoClose: 4000,
          //     pauseOnHover: true,
          //     draggable: true,
          //     theme: "light",
          //   });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getSingleCouponsData();
  }, []);
  return (
    <div className="createCoupons">
      <section>
        <div className="form_data">
          <div className="cross" onClick={() => navigate("/dashboard")}>
            <i className="bi bi-file-x-fill"></i>
          </div>
          <div className="form_heading">
            <h1>Create Coupons</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form_input">
              <label htmlFor="CouponsCode">Coupons Code</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.code}
                id="CouponsCode"
                name="code"
                placeholder="Coupons Code"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.description}
                id="description"
                name="description"
                placeholder="Description"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="discount">Discount Percent</label>
              <input
                type="number"
                onChange={onChangeInputHandler}
                value={inputHandler.discountPercent}
                id="discount"
                name="discountPercent"
                placeholder="Discount"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="minimumAmount">Minimum Amount</label>
              <input
                rows={10}
                onChange={onChangeInputHandler}
                value={inputHandler.minimumAmount}
                id="minimumAmount"
                name="minimumAmount"
                placeholder="minimum Amount"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="active">Active</label>
              <select
                id="active"
                name="active"
                value={inputHandler.active}
                onChange={onChangeInputHandler}
                required
              >
                <option value={true}>True</option>
                <option value={false}>False</option>
              </select>
            </div>
            <div className="form_input">
              <label htmlFor="minimumAmount">Max User</label>
              <input
                rows={10}
                onChange={onChangeInputHandler}
                value={inputHandler.maxUses}
                id="maxUses"
                name="maxUses"
                placeholder="Max User"
                required
              />
            </div>
            <button type="submit" className="btn">
              Update Product
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default UpdateCoupons;
